/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JobProgramMilestone } from '../models/JobProgramMilestone';
import type { JobProgramPaymentStatus } from '../models/JobProgramPaymentStatus';
import type { JobProgramStatus } from '../models/JobProgramStatus';
import type { JobServiceEquipment } from '../models/JobServiceEquipment';
import type { PaginatedResponse_JobListWithIncentiveAndEligibilityResponse_ } from '../models/PaginatedResponse_JobListWithIncentiveAndEligibilityResponse_';
import type { SortByOptions } from '../models/SortByOptions';
import type { SortDirectionOptions } from '../models/SortDirectionOptions';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class JobRoutesV2Repository {
  /**
   * Fetch Jobs
   * Lists jobs with rebate estimates and eligibility.
   *
   * Contractors see only their own jobs; internal users see jobs across all contractors.
   * Endpoint is paginated and filterable.
   * @returns PaginatedResponse_JobListWithIncentiveAndEligibilityResponse_ Successful Response
   * @throws ApiError
   */
  public static jobRoutesV2FetchJobs({
    isCanceled,
    searchToken,
    watchedJobs,
    hasContractorReadyTasks,
    readyToInstall,
    hasContractorActionOwner,
    paymentStatus,
    programId,
    jobProgramStatus,
    jobProgramMilestone,
    equipmentType,
    pageNumber = 1,
    perPage = 25,
    sortBy = 'install_start_date',
    sortDirection = 'desc',
    authorization,
  }: {
    isCanceled?: (boolean | null),
    searchToken?: (string | null),
    watchedJobs?: (boolean | null),
    hasContractorReadyTasks?: (boolean | null),
    readyToInstall?: (boolean | null),
    hasContractorActionOwner?: (boolean | null),
    paymentStatus?: (Array<JobProgramPaymentStatus> | null),
    programId?: (Array<string> | null),
    jobProgramStatus?: (Array<JobProgramStatus> | null),
    jobProgramMilestone?: (Array<JobProgramMilestone> | null),
    equipmentType?: (Array<JobServiceEquipment> | null),
    pageNumber?: number,
    perPage?: number,
    sortBy?: SortByOptions,
    sortDirection?: SortDirectionOptions,
    authorization?: string,
  }): CancelablePromise<PaginatedResponse_JobListWithIncentiveAndEligibilityResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/v2',
      headers: {
        'authorization': authorization,
      },
      query: {
        'is_canceled': isCanceled,
        'search_token': searchToken,
        'watched_jobs': watchedJobs,
        'has_contractor_ready_tasks': hasContractorReadyTasks,
        'ready_to_install': readyToInstall,
        'has_contractor_action_owner': hasContractorActionOwner,
        'payment_status': paymentStatus,
        'program_id': programId,
        'job_program_status': jobProgramStatus,
        'job_program_milestone': jobProgramMilestone,
        'equipment_type': equipmentType,
        'page_number': pageNumber,
        'per_page': perPage,
        'sort_by': sortBy,
        'sort_direction': sortDirection,
      },
      errors: {
        401: `Unauthorized`,
        422: `Validation Error`,
      },
    });
  }
}
